export default "__VITE_ASSET__fa3MUrHm__"